import { useState, useEffect } from "react";
import { API_BASE_URL, getAuthHeaders } from "../services/api";

/**
 * Module-level singleton so only ONE fetch/poll runs regardless of how many
 * components call useNotificationBanner().
 */
let _banner = { enabled: false, message: "", type: "warning", pages: [] };
let _listeners = new Set();
let _initialized = false;
let _intervalId = null;

const _notify = () => _listeners.forEach((fn) => fn({ ..._banner }));

const _fetchBanner = async () => {
	try {
		const res = await fetch(`${API_BASE_URL}/notification-banner`, {
			headers: getAuthHeaders(),
		});
		if (res.ok) {
			const data = await res.json();
			_banner = {
				enabled: data.enabled || false,
				message: data.message || "",
				type: data.type || "warning",
				pages: Array.isArray(data.pages) ? data.pages : [],
			};
			_notify();
		}
	} catch (err) {
		console.warn("Failed to fetch notification banner:", err);
	}
};

const _start = () => {
	if (_initialized) return;
	_initialized = true;
	_fetchBanner();
	_intervalId = setInterval(_fetchBanner, 5 * 60 * 1000);
};

const useNotificationBanner = () => {
	const [banner, setBanner] = useState({ ..._banner });

	useEffect(() => {
		_listeners.add(setBanner);
		_start(); // no-op after first call
		return () => {
			_listeners.delete(setBanner);
		};
	}, []);

	return { banner, refetch: _fetchBanner };
};

export default useNotificationBanner;
